module.exports = __webpack_public_path__ + "img/img_guide_delete_account_3.ed2e0fd7.png";